<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


// Get all pattern elements and dynamically set their background to the matching color
// const colors = document.querySelectorAll('.pattern');
// colors.forEach(color => {
//   const colorName = color.parentElement.getAttribute('title')?.toLowerCase();
//   if (colorName) {
//     color.style.backgroundColor = colorName;
//   }
// });

// Safely set background colors with full error handling
try {
  const colors = document.querySelectorAll('.pattern');
  if (colors.length > 0) {
    colors.forEach(color => {
      try {
        const colorName = color.parentElement?.getAttribute('title')?.toLowerCase();
        if (colorName) {
          color.style.backgroundColor = colorName;
        }
      } catch (err) {
        // Skip individual color elements that fail
        console.warn('Skipping pattern element:', err);
      }
    });
  }
} catch (err) {
  // Handle case where querySelectorAll fails entirely
  console.warn('No pattern elements found or DOM not ready:', err);
}

// space remvoe
document.querySelectorAll('.collection-description').forEach(el => {
  if (el.innerHTML.trim() === '&nbsp;' || !el.textContent.trim()) {
    el.style.display = 'none';
  }
});
